import React, { useState, useContext, useEffect, useRef } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { animated, useSpring } from '@react-spring/web';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../context/AuthContext';

import Loading from '../Common/Loading';
import ErrorBoundary from '../Common/ErrorBoundary';

import PageLayout from '../Layouts/PageLayout';
import Sidebar from '../CourseLearning/Sidebar/Sidebar';
import Flashcard from '../CourseLearning/Course/Flashcard';

import Test from '../CourseLearning/Course/Test';
import PDFReader from '../CourseLearning/Course/PDFReader';
import LiveSession from '../CourseLearning/Course/LiveSession';
import Quiz from '../CourseLearning/Course/Quiz';
import Unavailable from '../Common/Unavailable';
import ExternalEmbed from '../CourseLearning/ExternalEmbed';
import AudioPlayer from 'react-h5-audio-player';

import { ToastContainer } from 'react-toastify';

import {
    Player,
    ControlBar,
    PlayToggle,
    ReplayControl,
    ForwardControl,
    BigPlayButton,
    PlaybackRateMenuButton,
} from 'video-react';

// Import services for API calls
import { getCourseById } from '../services/instructors';
import { showError, showSuccess } from '../Utils/helper';

import 'react-h5-audio-player/lib/styles.css';
import 'video-react/dist/video-react.css';
import '../CourseLearning/CoursePage.css';

import TutorRevamp from '../AI/TutorRevamp';
import { FaAngleDoubleDown } from 'react-icons/fa';
import { FaRobot } from 'react-icons/fa';

const CoursePage = (props) => {
    const [activeComponent, setActiveComponent] = useState();
    const { loggedIn } = useContext(UserContext);
    const { user } = useContext(UserContext);

    // *course page*
    const [data, setData] = useState([]);
    const playerRef = useRef(null);
    const course_id = props.location.state;
    const [isDownloadable, setIsDownloadable] = useState(false);
    const [uniqueId, setUniqueId] = useState('');
    const [videoUrl, setVideoUrl] = useState('');
    const [videoState, setVideoState] = useState(null);
    const [currentLesson, setCurrentLesson] = useState(null);
    // const [viewMode, setViewMode] = useState('list');
    const [videoEnd, setVideoEnd] = useState(false);
    const [instructorToAsk, setInstructorToAsk] = useState(null);
    const [chapter_id, setChapterId] = useState(null);
    const [selectedItem, setSelectedItem] = useState('studyGuide');
    const [openChapters, setOpenChapters] = useState({});
    const [activeChapter, setActiveChapter] = useState(null);
    const [activeLessonID, setActiveLessonID] = useState(null);


    // *sidebar*
    const [view, setView] = useState('');

    // *flashcard*
    const [chapterData, setChapterData] = useState();
    const [flashcards, setFlashcards] = useState([]);
    // const [viewMode, setViewMode] = useState('list');

    // *quiz*
    const [quiz, setQuiz] = useState([]);
    const [check, setCheck] = useState([]);
    const [createNewQuiz, setCreateNewQuiz] = useState(false);

    // *loading *
    const [loading, setLoading] = useState(false);
    // const [error, setError] = useState(null);

    // *others
    const heightRef = useRef(null);
    const { t, i18n } = useTranslation();
    // const [loading, setLoading] = useState(false);
    const [counter, setCounter] = useState(false);
    const [height, setHeight] = useState(0);

    const contentRef = useRef(null); // Reference for content
    const sidebarRef = useRef(null); // Reference for sidebar

    const [resp, setResp] = useState([]);

    const [openTutor, setOpenTutor] = useState(false); // Tutor visibility state
    const { setChatbotAvailable } = props; // Function to set chatbot availability

    // Animation for the tutor icon
    const springs = useSpring({
        transform: openTutor ? 'rotate(360deg)' : 'rotate(0deg)',
    });

    // Spring properties for scaling
    const [springProps, set] = useSpring(() => ({ scale: 1 }));

    const handleLessonClick = async (lesson, task = {}) => {
        // if (!lesson) {
        //     throw new Error('Lesson data is unavailable');
        // }

        if (lesson?.type === 'quiz' || lesson?.type === 'live-session') {
            // setLoading(false);
            setCurrentLesson(lesson);
            setView(lesson?.type);
        } else {
            // setLoading(false);
            // if (!lesson?.media?.[0]?.url) {
            //     throw new Error('Media content is currently unavailable');
            // }
            setVideoUrl(lesson?.media[0]?.url);
            setCurrentLesson(lesson);
            setVideoEnd(false);
            setView(lesson?.media[0]?.media_type);
            setIsDownloadable(lesson?.media[0]?.is_downloadable);
        }
    }

    const handleTaskClick = (_lesson, task = {}) => {
        // setLoading(true);

        setActiveLessonID(_lesson?.id);
        setActiveComponent('Course');
        handleLessonClick(_lesson, task);

        // Scroll to top smoothly
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // for smooth scrolling
        });

        // Scroll course content list to top
    };

    async function toGetCourseById() {
        setLoading(true);
        const resp = await getCourseById(course_id);
        setResp(resp);
        if (resp.success) {
            setData(resp.data);
            if (resp?.data?.chapter[0]?.lessons[0]?.media[0]?.is_downloadable === 1) {
                setIsDownloadable(true);
            }
            setVideoUrl(resp?.data?.chapter[0]?.lessons[0]?.media[0]?.url);
            setCurrentLesson(resp?.data?.chapter[0]?.lessons[0]);
            setView(
                resp?.data?.chapter[0]?.lessons[0]?.quiz?.length > 0
                    ? 'quiz'
                    : resp?.data?.chapter[0]?.lessons[0]?.media[0]?.media_type
            );
            setLoading(false);
        } else {
            showError('Somthing went wrong');
            setLoading(false);
            console.log('course page - error', resp);
        }
    }

    const renderActiveComponent = () => {
        // Check for unavailable content
        // if (!currentLesson || !view || (view !== 'quiz' && view !== 'live-session' && !videoUrl)) {
        //     return <Unavailable />;
        // }
        // if (!currentLesson || !view || (view !== 'quiz' && view !== 'live-session' && !videoUrl)) {
        //     return <Unavailable />;
        // }
        // if (!view) {
        //     return <Unavailable />;
        // }
        const components = {
            Course: (
                <div className="course__container">
                    {view === 'video' && (
                        <div className="course_video">
                            <Player
                                src={process.env.REACT_APP_CONTENT_URL + videoUrl}
                                ref={playerRef}
                                fluid={true}
                                width="100%"
                                height="100%"
                            >
                                <BigPlayButton position="center" />

                                <ControlBar autoHide={false}>
                                    <PlayToggle />
                                    <ReplayControl seconds={10} order={2.2} />
                                    <ForwardControl seconds={10} order={3.2} />
                                    <PlaybackRateMenuButton rates={[2, 1, 1.75, 1.5]} />
                                </ControlBar>
                            </Player>
                        </div>
                    )}

                    {view === 'image' && (
                        <img src={process.env.REACT_APP_CONTENT_URL + videoUrl} class="responsive-image" alt={data?.name} />
                    )}
                    {view === 'audio' && (
                        <div className="course_video">
                            <AudioPlayer
                                autoPlay
                                src={process.env.REACT_APP_CONTENT_URL + videoUrl}
                                showSkipControls={false}
                                loop={false}
                            />
                        </div>
                    )}

                    {view === 'pdf' && <PDFReader videoUrl={videoUrl} isDownloadable={isDownloadable} />}
                    {view === 'live-session' && (
                        <LiveSession
                            name={currentLesson?.name}
                            url={currentLesson?.live_session[0]?.url}
                            date={currentLesson?.live_session[0]?.session_date}
                        />
                    )}
                    {view === 'quiz' && (
                        <Test key={uniqueId} quiz={currentLesson} course_id={course_id} uniqueId={uniqueId} />
                    )}
                    {['external_reference', 'external_media', 'educational_game'].includes(view) && (
                        <ExternalEmbed url={videoUrl} type={view} />
                    )}
                    {!view && <Unavailable />}
                </div>
            ),
            Quiz: (
                <Quiz
                    // activeSidebar={activeSidebar}
                    chapterData={chapterData}
                    // handleActiveSidebar={handleActiveSidebar}
                    chapter={chapterData?.chapterName}
                    course_id={data?.id}
                    chapter_id={chapter_id}
                    quiz={quiz}
                    setCreateNewQuiz={setCreateNewQuiz}
                    // createNewQuiz={createNewQuiz}
                />
            ),
            Flashcard: (
                <Flashcard
                    chapterData={chapterData}
                    chapter={chapterData?.chapterName}
                    course_id={data?.id}
                    chapter_id={chapter_id}
                    flashcards={flashcards}
                />
            ),
        };
        return components[activeComponent] || components.Course;
    };

    // Function to handle instructor selection for questions
    const handleChooseQAInstructor = (event) => {
        setInstructorToAsk(event.target.value);
    };

    // Effect to prevent right-click context menu and fetch course data
    useEffect(() => {
        document.addEventListener('contextmenu', (e) => {
            e.preventDefault();
        });
        toGetCourseById();
    }, []);

    // Effect to subscribe to video player state changes
    useEffect(() => {
        if (playerRef.current) {
            playerRef.current.subscribeToStateChange((e) => {
                setVideoState(e);
            });
        }
    });

    // Effect to handle video completion
    useEffect(() => {
        if (videoState && videoState?.ended && !videoEnd) {
            setVideoEnd(true);
        }
    }, [videoState]);

    // Effect to redirect if not logged in
    useEffect(() => {
        if (!loggedIn) {
            <Redirect to="/" />;
        }
    }, [loggedIn]);

    useEffect(() => {
        setChatbotAvailable(false);
        return () => {
            setChatbotAvailable(true);
        };
    }, []);

    useEffect(() => {
        let resizeObserver;

        // Debounce the resize callback
        const updateHeight = () => {
            if (contentRef.current && sidebarRef.current) {
                requestAnimationFrame(() => {
                    sidebarRef.current.style.height = `${contentRef.current.clientHeight}px`;
                });
            }
        };

        if (contentRef.current) {
            resizeObserver = new ResizeObserver((entries) => {
                // Use requestAnimationFrame to avoid the loop warning
                window.requestAnimationFrame(() => {
                    updateHeight();
                });
            });

            resizeObserver.observe(contentRef.current);
        }
        // Cleanup
        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [data]);

    return (
        <>
            <PageLayout>
                <div className="course-page">
                    <div className="course-page__sidebar" ref={sidebarRef}>
                        <Sidebar
                            setActiveComponent={setActiveComponent}
                            courseData={data}
                            setChapterData={setChapterData}
                            currentLesson={currentLesson}
                            check={check}
                            markAsCompleted={null}
                            unmarkComplete={null}
                            setCurrentLesson={setCurrentLesson}
                            setView={setView}
                            setVideoUrl={setVideoUrl}
                            setVideoEnd={setVideoEnd}
                            setIsDownloadable={setIsDownloadable}
                            setUniqueId={setUniqueId}
                            course_id={course_id}
                            course_title={data?.name}
                            setFlashcards={setFlashcards}
                            // setViewMode={setViewMode}
                            // viewMode={viewMode}
                            setQuiz={setQuiz}
                            setChapterId={setChapterId}
                            setLoading={setLoading}
                            // setError={setError}
                            loading={loading}
                            // error={error}
                            setCreateNewQuiz={setCreateNewQuiz}
                            createNewQuiz={createNewQuiz}
                            selectedItem={selectedItem}
                            setSelectedItem={setSelectedItem}
                            openChapters={openChapters}
                            setOpenChapters={setOpenChapters}
                            activeChapter={activeChapter}
                            setActiveChapter={setActiveChapter}
                            handleTaskClick={handleTaskClick}
                        />
                    </div>

                    <ErrorBoundary>
                        <div className="course-page__content" ref={contentRef}>
                            {/* <Suspense fallback={<Loading type="text" />}>{renderActiveComponent()}</Suspense> */}
                            {loading ? <Loading type="text" /> : renderActiveComponent()}
                            {/* {renderActiveComponent()} */}
                            <ToastContainer />
                        </div>
                    </ErrorBoundary>
                </div>
            </PageLayout>
            <>
                <animated.div
                    id="chatbot-icon"
                    style={{ transform: springProps.scale.to((s) => `scale(${s})`) }}
                    onClick={() => {
                        setOpenTutor(!openTutor);
                        set({ scale: 0.7 });
                        setTimeout(() => {
                            set({ scale: 1 });
                        }, 150);
                    }}
                >
                    {openTutor ? (
                        <animated.div style={{ ...springs }}>
                            <FaAngleDoubleDown />
                        </animated.div>
                    ) : (
                        <animated.div style={{ ...springs }}>
                            <FaRobot style={{ marginBottom: '5px' }} />
                        </animated.div>
                    )}
                </animated.div>

                {openTutor ? <TutorRevamp course_id={parseInt(course_id)} course_name={data?.name} /> : null}
            </>
        </>
    );
};

export default withRouter(CoursePage);
